var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book-content"},[_c('navBar',[_vm._v(_vm._s(_vm.currentTitle))]),_c('div',{staticClass:"content-box"},[(_vm.menuData.length)?_c('menuPage',{attrs:{"menuData":_vm.menuData,"navType":_vm.navType}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }